import React, { useContext } from 'react';
import { Link } from "gatsby-plugin-intl"
import { ThemeContext } from 'providers/ThemeProvider';
import { Container } from 'components/common';
import NavbarLinks from '../NavbarLinks';
import { Wrapper, Brand } from './styles';
import Logo from '../Logo';

const Navbar = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <Wrapper as={Container}>
      <NavbarLinks desktop />
      <Brand as={Link} to="/" theme={theme}>
        <Logo />
      </Brand>
    </Wrapper>
  );
};

export default Navbar;
